module.exports = __webpack_public_path__ + "media/packs/images/partners/partner2-bea4db94a86fcdadfc3fb400b0762926.jpg";